import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { FormattedHTMLMessage } from 'sb-react-intl'
import { date, constants, compose } from 'common/helpers'
import injectGlobals from 'decorators/injectGlobals'

import Box from 'components/_new/layout/Box/Box'
import Button from 'components/buttons/Button/Button'
import Modal from 'components/modal/Modal/Modal'
import Link from 'components/ui/Link/Link'
import { Cell, Grid } from 'components/_new/layout/grid'

import MonthsButton from './MonthsButton/MonthsButton'

import messages from './messages'
import s from './SkipAMonthModal.scss'


class SkipAMonthModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    isSkinOptionsEnabled: PropTypes.bool,
  }

  static defaultProps = {
    name: constants.modals.SkipAMonth,
  }

  state = {
    selectedMonthsCount: null,
  }

  selectMonths = (count) => {
    this.setState({
      selectedMonthsCount: count,
    })
  }

  handleSkipMonths = () => {
    const { selectedMonthsCount } = this.state
    const { data: { onSuccess } } = this.props

    actions.models.modals.open(constants.modals.SkipAMonthSuccess, { monthCount: selectedMonthsCount })

    if (typeof onSuccess === 'function') {
      onSuccess()
    }
  }

  skipMonths = () => {
    const { selectedMonthsCount } = this.state

    actions.models.ui.showRequestLoader()
    actions.models.subscription.skipMonths({ count: selectedMonthsCount })
      .finally(() => {
        actions.models.ui.hideRequestLoader()
        this.close()
      })
      .then((refund) => {
        if (refund) {
          actions.models.modals.open(constants.modals.cancelSubscription.RefundOnTheDayOfCharge, {
            ...refund,
            onClose: this.handleSkipMonths,
          })

          return
        }

        this.handleSkipMonths()
      }, () => {})
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { selectedMonthsCount } = this.state
    const { name, nextShippingDate, isSkinOptionsEnabled } = this.props

    const nextShippingMonth = date.formatDate(nextShippingDate, 'MMM DD')
    const months = isSkinOptionsEnabled ? 6 : 3

    return (
      <Modal name={name} title={messages.title}>
        <FormattedHTMLMessage tag="div" {...messages.text} values={{ month: nextShippingMonth }} />
        <Grid className={s.monthsButtons} columns={3}>
          {
            Array
              .apply(null, { length: months })
              .map(Number.call, Number)
              .map((index) => {
                const num = index + 1

                return (
                  <Cell key={index} className={s.monthsButton}>
                    <MonthsButton
                      active={selectedMonthsCount === num}
                      count={num}
                      onClick={this.selectMonths}
                    />
                  </Cell>
                )
              })
          }
        </Grid>
        {
          selectedMonthsCount && (
            <Button
              className={s.confirmButton}
              gray
              lg
              title={messages.confirmButton}
              onClick={this.skipMonths}
              dataTestId={constants.testIds.skipAMonth.confirmButton}
            />
          )
        }
        <Box alignCenter>
          <Link blackColor title={messages.back} onClick={this.close} />
        </Box>
      </Modal>
    )
  }
}


export default compose(
  injectGlobals(({ getFeatureToggle }) => ({
    isSkinOptionsEnabled: getFeatureToggle(constants.features.skipOptions),
  })),
  connect({
    nextShippingDate: 'models.subscription.nextShippingDate',
  }),
)(SkipAMonthModal)
